<template>
  <div>
    <v-container class="content-wrapper" fluid id="campaign-tab">
      <!-- Campaign & Campaign Applicants buttons -->
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" md="6" class="justify-center d-flex">
          <v-btn-toggle v-model="toggleCampaign" rounded mandatory>
            <v-btn value="campaign" class="btn-selected">
              Campaign
            </v-btn>
            <v-btn value="campaignApplicants" class="btn-selected">
              Campaign Applicants
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Campaign -->
      <v-row v-if="toggleCampaign === 'campaign'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Campaign
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleCampaign === 'campaign'">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <TableCampaign
              :url-api="'/api/v1/campaign'"
              :search="search"
              :search-attributes="['title']"
            ></TableCampaign>
          </v-card>
        </v-col>
      </v-row>

      <!-- Campaign Applicants -->
      <v-row v-if="toggleCampaign === 'campaignApplicants'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Campaign Applicants
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleCampaign === 'campaignApplicants'">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <TableCampaignApplicants
              :url-api="'/api/v1/campaign/campaign-applicants'"
              :search="search"
              :search-attributes="['name']"
            ></TableCampaignApplicants>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TableCampaign from '@/components/admin/campaign/TableCampaign.vue';
import TableCampaignApplicants from './TableCampaignApplicants.vue';

export default {
  name: 'Campaign',
  components: {
    TableCampaign,
    TableCampaignApplicants,
  },
  data: () => ({
    toggleCampaign: 'campaign',
    search: {},
  }),
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
